import { render, staticRenderFns } from "./customer-and-vendor-invoice-statistic.vue?vue&type=template&id=f39e34bc&scoped=true&"
import script from "./customer-and-vendor-invoice-statistic.vue?vue&type=script&lang=js&"
export * from "./customer-and-vendor-invoice-statistic.vue?vue&type=script&lang=js&"
import style0 from "./customer-and-vendor-invoice-statistic.vue?vue&type=style&index=0&id=f39e34bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39e34bc",
  null
  
)

export default component.exports